// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.filter-container[data-v-2bf58d14] {\n  margin-bottom: 20px;\n}\n.filter-item[data-v-2bf58d14] {\n  margin-right: 10px;\n  margin-bottom: 10px;\n}\n.warranty-expired[data-v-2bf58d14] {\n  color: #f56c6c;\n  font-weight: bold;\n}\n", ""]);
// Exports
module.exports = exports;
